export const tabsList = `
  grid
  auto-cols-[minmax(0,80px)]
  grid-flow-col
  px-0 py-4
`;

export const trigger = `
  bg-none
  border-none
  p-1
  flex
  flex-col
  items-center
  hover:cursor-pointer
  fill-ll-disabled
  text-ll-disabled
  hover:fill-ll-primary
  hover:text-ll-primary
  [&>div]:fill-inherit
  [&>div]:text-inherit
  data-[active=true]:fill-ll-primary
  data-[active=true]:text-ll-primary
`;

export const icon = `
  w-6 h-6
  fill-inherit
`;
export const tabText = `
  m-0 font-semibold
  text-ll-font-size-caption-1
  text-inherit
`;
